import { Text, Box, Badge, Flex, Divider } from '@chakra-ui/react';

const Enforcement = ({ entitlement }) => {
  const isEnforced = entitlement.valueBool === true;

  return (
    <Flex direction="column">
      <Text textStyle="bodyFamilySemiBold" fontSize="18px">
        {entitlement.name}
      </Text>
      <Divider border="1px solid lightGrey" mt={2} />
      <Box mt={6}>
        <Badge fontSize="14px" variant={isEnforced ? 'pending' : 'active'}>
          {isEnforced ? 'Enforced' : 'Removed'}
        </Badge>
      </Box>
    </Flex>
  );
};

export default Enforcement;
